<template>
  <div>
    <Header></Header>
    <div class="sign_up_page">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 order-2 order-lg-1">
            <div class="sign_up_box">
              <h1>{{ $t("auth.signup.sign_up_title") }}</h1>
              <template v-if="show_google">
                <a href="#" class="google_btn" @click.prevent="googleAuth">
                  <span>{{ $t("auth.signup.continue_google") }}</span>
                </a>
                <div
                  id="appleid-signin"
                  data-color="black"
                  data-border="true"
                  data-type="sign in"
                ></div>
                <hr />
              </template>
              <div class="input_box">
                <div class="label">{{ $t("auth.signup.name") }}</div>
                <input
                  type="text"
                  :placeholder="$t('auth.signup.name_placeholder')"
                  v-model="name"
                />
              </div>
              <div class="input_box email">
                <div class="label">{{ $t("auth.signup.email") }}</div>
                <input
                  type="email"
                  :placeholder="$t('auth.signup.email_placeholder')"
                  v-model="email"
                />
              </div>
              <div v-if="show_password" class="input_box">
                <div class="label">{{ $t("auth.signup.password") }}</div>
                <input
                  type="text"
                  :placeholder="$t('auth.signup.password_placeholder')"
                  v-model="password"
                />
                <img
                  :src="require('@/assets/static/images/auth/pass_show.svg')"
                  alt=""
                  @click="show_password = false"
                />
              </div>
              <div v-else class="input_box">
                <div class="label">{{ $t("auth.signup.password") }}</div>
                <input
                  type="password"
                  :placeholder="$t('auth.signup.password_placeholder')"
                  v-model="password"
                />
                <img
                  :src="require('@/assets/static/images/auth/pass_hide.svg')"
                  alt=""
                  @click="show_password = true"
                />
              </div>
              <div v-if="error" class="error_msg">{{ error }}</div>
              <div class="auth-button" :class="button_disabled ? 'active' : ''">
                <a href="#" class="button" @click.prevent="registration">{{
                  $t("auth.signup.sign_up_email")
                }}</a>
                <div class="image-pre-loader image-pre-loader-red"></div>
              </div>
              <p class="small">
                {{ $t("auth.signup.terms_text") }}
                <a href="https://taskpal.com/terms-of-service">{{
                  $t("auth.signup.terms_of_service")
                }}</a>
                {{ $t("auth.signup.and") }}
                <a href="https://taskpal.com/privacy-policy">{{
                  $t("auth.signup.privacy_policy")
                }}</a
                >.
              </p>
              <hr />
              <p class="text-center small">
                {{ $t("auth.signup.already_have_account") }}
                <router-link to="/login">{{
                  $t("auth.signup.sign_in_link")
                }}</router-link>
              </p>
            </div>
          </div>
          <div class="col-lg-6 order-1 order-lg-2">
            <div class="sign_up_img">
              <img
                :src="require('@/assets/static/images/auth/sign.svg')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#appleid-signin {
  width: 100%;
  height: 50px;
  margin-bottom: 15px;
  cursor: pointer;
}
#appleid-signin div {
  max-width: none !important;
}
</style>

<script>
import "@/assets/styles/auth/main.scss";
import { mapActions } from "vuex";
import passwordValidator from "password-validator";
import Header from "@/components/auth/Header";

export default {
  data: () => ({
    name: "",
    email: "",
    password: "",
    error: "",
    show_password: false,
    show_google: true,
    button_disabled: false,
    password_valid: false,
    list_id: "",
    user_id: "",
    chat_id: "",
    prod: process.env.VUE_APP_MODE,
  }),
  components: {
    Header,
  },
  async mounted() {
    if (localStorage.getItem("login_no_data")) {
      this.error = this.$t("auth.errors.apple_login_error");
      localStorage.removeItem("login_no_data");
    }

    this.initAppleLogin();
    document.title = this.$t("auth.signup.sign_up_title") + " | TaskPal";
    document.querySelector("body").classList.add("intropage");

    if (process.env.VUE_APP_MODE != "production") {
      this.show_google = false;
    }

    if (this.$router.history.current.query.code) {
      let data = await this.InvitationDecrypt(
        this.$router.history.current.query.code
      );
      this.email = data.email;
      this.list_id = data.list_id;
      this.user_id = data.user_id;
      this.chat_id = data.chat_id;
      this.show_google = false;
      document.querySelector(".email input").setAttribute("disabled", "");
    }
  },
  unmounted() {
    document.querySelector("body").classList.remove("intropage");
  },
  methods: {
    ...mapActions(["register", "InvitationDecrypt"]),
    async initAppleLogin() {
      try {
        localStorage.setItem("register_new_user_date", new Date().getTime());
        AppleID.auth.init({
          clientId: "com.taskpalllc.taskpal.sign",
          scope: "name email",
          redirectURI: process.env.VUE_APP_API_BASE_URL2 + "/auth",
          state: "taskpal",
          nonce: "nonce",
          usePopup: false,
        });
      } catch (error) {
        console.error("Apple Sign-In Error:", error);
      }
    },
    async registration() {
      if (this.button_disabled) return;
      if (this.password_valid) return;

      this.error = "";

      if (!this.name) return (this.error = this.$t("auth.signup.enter_name"));
      if (this.name.length < 3 || this.name.length > 25)
        return (this.error = this.$t("auth.signup.name_length"));

      if (!this.email) return (this.error = this.$t("auth.signup.enter_email"));
      if (this.email.length > 40)
        return (this.error = this.$t("auth.signup.email_length"));
      if (!this.$w_email_validate(this.email))
        return (this.error = this.$t("auth.signup.invalid_email"));

      if (!this.password)
        return (this.error = this.$t("auth.signup.enter_password"));

      if (this.error != "") return;

      this.button_disabled = true;

      const result = await this.register({
        url: this.$w_api.SIGN_UP,
        body: {
          email: this.email,
          password: window.btoa(this.password),
          name: this.name,
          color: this.$w_user_color[Math.floor(Math.random() * 37)],
          list_id: this.list_id,
          user_id: this.user_id,
          chat_id: this.chat_id,
        },
      });

      if (result === true) {
        localStorage.setItem("register_new_user_date", new Date().getTime());
        setTimeout(() => (window.location.href = "/"), 1000);
      } else {
        setTimeout(() => {
          this.button_disabled = false;
          this.error = result;
        }, 500);
      }
    },
    googleAuth() {
      localStorage.setItem("register_new_user_date", new Date().getTime());
      if (document.isElectron) {
        const link = document.createElement("a");
        link.id = "googleauthlink";
        link.target = "_blank";
        link.href = process.env.VUE_APP_API_BASE_URL2 + "/auth/google";
        document.getElementById("googleauthlink").click();
      } else {
        window.location.href =
          process.env.VUE_APP_API_BASE_URL2 + "/auth/google";
      }
    },
  },
  watch: {
    password(e) {
      this.password_valid = true;
      if (e == "") {
        this.error = this.$t("auth.signup.enter_password");
      } else {
        var schema = new passwordValidator();
        schema.is().min(8).is().max(100).is().not().oneOf(this.$w_password);

        let valid = schema.validate(e, { list: true });
        if (valid.length > 0) {
          if (valid[0] == "min")
            this.error = this.$t("auth.signup.password_min");
          if (valid[0] == "max")
            this.error = this.$t("auth.signup.password_max");
          if (valid[0] == "uppercase")
            this.error = this.$t("auth.signup.password_uppercase");
          if (valid[0] == "lowercase")
            this.error = this.$t("auth.signup.password_lowercase");
          if (valid[0] == "digits")
            this.error = this.$t("auth.signup.password_digits");
          if (valid[0] == "spaces")
            this.error = this.$t("auth.signup.password_spaces");
          if (valid[0] == "oneOf")
            this.error = this.$t("auth.signup.password_easy");
        } else {
          this.password_valid = false;
          this.error = "";
        }
      }
    },
  },
};
</script>
